import { useCallback } from 'react';
import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';
import { getParsedEnrollmentFormFields } from '../utils/applicant-info-fields';
import {
  EnrollmentApplicationResponse,
  EnrollmentFormFields,
} from '../widgets/care-credit-enrollment-multi-step/enrollment-multi-step.types';

export type UseCareCreditEnrollmentSubmitApplicationProps = {
  merchantNumber: string | undefined;
  locationId: string | undefined;
};
export const useCareCreditEnrollmentSubmitApplication = ({
  merchantNumber,
  locationId,
}: UseCareCreditEnrollmentSubmitApplicationProps) => {
  const { mutateAsync, error, isLoading, isSuccess } =
    CareCreditIntegrationV1.Mutations.usePrequalificationOfferMutation({
      options: {},
    });

  const submitApplication = useCallback(
    async (fields: EnrollmentFormFields): Promise<EnrollmentApplicationResponse> => {
      if (!merchantNumber) {
        throw new Error('Merchant number is required to submit CareCredit enrollment application');
      }
      const {
        // personal info
        firstName,
        lastName,
        email,
        dateOfBirth,
        ssn,
        // annualIncome,
        annualIncomeNumber,

        // contact info
        phoneNumber,
        phoneNumberType,

        // formatted ID fields
        idExpirationDate,
        idNumber,

        // address
        address,
        address2,
        city,
        state,
        postalCode,
      } = getParsedEnrollmentFormFields(fields);

      const res = await mutateAsync({
        locationId,
        merchantNumber,
        checkAccountExistence: false,
        ssn,
        annualIncome: annualIncomeNumber,
        applicantInfo: {
          firstName: firstName,
          lastName: lastName,
          email: email,
          dateOfBirth,

          contactInfo: [
            {
              contactExtension: '',
              contactType: phoneNumberType,
              contactNumber: phoneNumber,
            },
          ],
          address: {
            addressLine1: address,
            addressLine2: address2,
            city: city,
            state: state,
            zipCode: postalCode,
          },
        },
        identificationInfo: [
          {
            identificationType: fields.idType,
            identificationNumber: idNumber,
            issuedBy: {
              issuerCountry: fields.idCountry,
              issuerState: fields.idState,
            },
            expiryDate: idExpirationDate,
            identityVerified: true,
          },
        ],
      });

      return res;
    },
    [merchantNumber, locationId]
  );

  return { submitApplication, isSubmitting: isLoading, isSuccess, error };
};
